export const components = {
  Close: 'Cerrar',
  "Hello, I'd like to talk with someone at the {{unit}} clinic":
    'Hola, me gustaría hablar con alguien de la clínica {{unit}}',
  'Mon to Fri': 'Lun a Vie',
  Sat: 'Sáb',
  'Service hours': 'Horarios de atención',
  '{{start}} until {{end}}': '{{start}} a {{end}}',
  '{{street}}, N {{number}} - {{district}}':
    '{{street}}, nº{{number}} - {{district}}',
  Sun: 'Dom',
  'Talk to the clinic': 'Hablar con la clínica',
  'Unit information': 'Información de la unidad',
  'See more details': 'Ver más detalles',
};
